import { Type } from '@sinclair/typebox';
import { priceMajorMinorSimpleSchema, shippingMethodPriceSchema, shippingMethodPriceSchemaV2 } from "../price.mjs";
export const deliveryEstimateSchema = Type.Object({
    formattedDate: Type.String(),
    minDate: Type.Number(),
    maxDate: Type.Number(),
});
export const shippingMethodSchemaLegacy = Type.Object({
    id: Type.String(),
    name: Type.String(),
    title: Type.String(),
    type: Type.String(),
    price: shippingMethodPriceSchema,
    image: Type.Object({
        url: Type.String(),
        alt: Type.String(),
    }),
    deliveryEstimate: deliveryEstimateSchema,
});
export const shippingMethodSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    title: Type.String(),
    type: Type.String(),
    price: shippingMethodPriceSchemaV2,
    image: Type.Object({
        url: Type.String(),
        alt: Type.String(),
    }),
    deliveryEstimate: deliveryEstimateSchema,
});
export const totalAmountForFreeShipping = Type.Object({
    normal: Type.Union([Type.Number(), Type.Null()]),
    fast: Type.Union([Type.Number(), Type.Null()]),
    express: Type.Union([Type.Number(), Type.Null()]),
});
export const totalAmountForFreeShippingMajorMinor = Type.Object({
    normal: Type.Union([priceMajorMinorSimpleSchema, Type.Null()]),
    fast: Type.Union([priceMajorMinorSimpleSchema, Type.Null()]),
    express: Type.Union([priceMajorMinorSimpleSchema, Type.Null()]),
});
export const checkoutPageShippingSchema = Type.Object({
    $type: Type.Literal('checkoutPage'),
    shippingMethods: Type.Array(shippingMethodSchemaLegacy),
    selectedShippingMethod: Type.Optional(shippingMethodSchemaLegacy),
});
export const cartShippingSchema = Type.Union([checkoutPageShippingSchema]);
//# sourceMappingURL=shipping.js.map